module.exports = __webpack_public_path__ + "img/gallery-3.814ed9ef.jpg";